<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<ng-container *ngIf="fullContent">
    <ng-container *ngTemplateOutlet="template2"></ng-container>
</ng-container>
<ng-container *ngIf="!fullContent">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</ng-container>


<ng-template #template2>
    <div class="container-fluid full-layout">
        <router-outlet></router-outlet>
    </div>
</ng-template>

<ng-template #template>
        <div>
            <router-outlet name="navbar"></router-outlet>
        </div>
    
        <div class="container-fluid">
            <div class="sidebar-container d-none d-md-block" *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
                <router-outlet name="sidebar"></router-outlet>
            </div>
            <div class="card jh-card">
                <router-outlet></router-outlet>
            </div>
        </div>
</ng-template>
